import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const sectors = [
  "Hostelería",
  "Retail",
  "Servicios profesionales",
  "Industria",
  "Logística",
  "Salud",
  "Educación",
  "Construcción",
  "Consultoría",
  "Alimentación",
  "Turismo",
  "Inmobiliaria",
];

export default function SectorsStrip() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section
      data-testid="sectors-section"
      ref={ref}
      className="relative py-20 md:py-28 px-6 md:px-12 overflow-hidden"
    >
      <div className="hr-glow absolute top-0 left-0 right-0" />

      <div className="max-w-5xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-[#6B7FD7] text-sm font-medium tracking-[0.3em] uppercase mb-10"
        >
          Para todos los sectores
        </motion.p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {sectors.map((sector, i) => (
            <motion.span
              key={sector}
              data-testid={`sector-tag-${i}`}
              initial={{ opacity: 0, y: 20, scale: 0.9 }}
              animate={isInView ? { opacity: 1, y: 0, scale: 1 } : {}}
              transition={{
                duration: 0.5,
                delay: i * 0.05,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ scale: 1.08, borderColor: "rgba(0,229,255,0.4)" }}
              className="inline-block px-5 py-2.5 rounded-full text-xs sm:text-sm font-medium tracking-wide text-white/60 border border-white/[0.08] bg-white/[0.02] hover:text-white/90 hover:bg-white/[0.05] transition-all duration-300 cursor-default"
            >
              {sector}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
